import deMessages from "./messages/de_DE.json";
import frMessages from "./messages/fr.json";
import zhcnMessages from "./messages/zh_CN.json";

const messages = {
  fr: frMessages,
  "zh-cn": zhcnMessages,
  "de-de": deMessages,
};

export default messages;
